import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';


const LNG_KEY = 'SELECTED_LANGUAGE';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  selected = '';

  constructor(private translate: TranslateService, private storage: Storage, private platform: Platform) { }


  setInitialAppLanguage() {
    const language = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);

    this.cargarStorage();

  }

  getLanguages() {
    return [
      { text: 'English', value: 'en', img: 'assets/imgs/en.png'},
      { text: 'Frances', value: 'fr', img: 'assets/imgs/fr.png'},
      { text: 'Español', value: 'es', img: 'assets/imgs/es.png'},
    ];
  }


  setLanguage(lng) {
    this.translate.use(lng);
    this.selected = lng;


    if (this.platform.is('capacitor')) {
      //estamos en el dispositivo
      this.storage.set(LNG_KEY, lng);
    } else {
      //estamos en la computadora
      localStorage.setItem(LNG_KEY, lng);
    }
  }


  cargarStorage(){
    const promesa = new Promise ((resolve, reject ) => {
      if (this.platform.is('capacitor')) {
        //estamos en el dispositivo
                    this.storage.get(LNG_KEY)
                            .then ( val => {
                              this.setLanguage(val);
                              this.selected = val;
                              resolve( true );
                            });

      } else {
        //estamos en la computadora
        const val = localStorage.getItem(LNG_KEY) || 'es';

        this.setLanguage(val);
        this.selected = val;

        resolve( true );
      }
    });
  }


}
